/*
 * What this delete is about to break.
 *
 * Every destructive action in the panel was a yes/no question with no facts
 * attached. Some are refused by the server afterwards - "the stop has routes,
 * you can not delete it" - which is a wall arrived at rather than a warning;
 * the rest go through and take things with them, because a child's stop is a
 * foreign key that is set to null when the row it points at disappears. Nobody
 * finds out until the morning.
 *
 * So ask first, and put the answer in the confirmation: what is attached, whose
 * morning it changes, and whether the thing can be deleted at all.
 *
 * Usage:
 *
 *   import deleteImpact from "@/mixins/deleteImpact";
 *   export default { mixins: [deleteImpact], ... }
 *
 *   this.confirmDelete({ type: "stop", id: stop.id, title: this.$t("delete_stop") })
 *     .then((confirmed) => { if (confirmed) ... })
 */
export default {
  methods: {
    /**
     * @returns {Promise<boolean>} true when the school confirmed and nothing blocks it
     */
    confirmDelete({ type, id, title, text, confirmText }) {
      return axios
        .get("/school-impact", { params: { type: type, id: id } })
        .then((response) => this.showImpact(response.data, { title, text, confirmText }))
        .catch(() => {
          //the warning is a courtesy; failing to fetch it must not stop the
          //school from deleting something
          return this.$confirmAction({
            title: title,
            text: text || this.$t("confirm_delete_generic"),
            icon: "warning",
            confirmText: confirmText || this.$t("yes"),
          });
        });
    },

    showImpact(impact, { title, text, confirmText }) {
      const blocks = impact.blocks || [];
      const warnings = impact.warnings || [];
      const students = impact.students || [];

      //the server is going to refuse this, so say so instead of pretending
      if (blocks.length) {
        this.$swal(
          title,
          "<p>" + blocks.map(this.escape).join("</p><p>") + "</p>",
          "error"
        );

        return Promise.resolve(false);
      }

      let body = "<p>" + this.escape(text || this.$t("confirm_delete_generic")) + "</p>";

      if (warnings.length) {
        body +=
          '<ul style="text-align:start">' +
          warnings.map((line) => "<li>" + this.escape(line) + "</li>").join("") +
          "</ul>";
      }

      if (students.length) {
        body +=
          '<p style="text-align:start"><b>' +
          this.escape(this.$t("children_affected")) +
          ":</b> " +
          this.escape(students.join(", ")) +
          "</p>";
      }

      return this.$swal
        .fire({
          title: title,
          html: body,
          icon: warnings.length ? "warning" : "question",
          showCancelButton: true,
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: confirmText || this.$t("yes"),
        })
        .then((result) => result.isConfirmed === true);
    },

    //the names come from a database somebody else types into
    escape(value) {
      return String(value === null || value === undefined ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
  },
};
